// @ts-nocheck
import classnames from 'clsx'
import { bool, number, string } from 'prop-types'
import { Helmet } from 'react-helmet'

import { chooseSrcByWidth } from 'shared/utils/imageUtils'
import { InferPropsWithDefaults } from 'shared/utils/propTypes'
import { sizesPropType, srcSetPropType } from 'views/utils/propTypes/img'

import { sortSrcSet, transformSizes, transformSrcSet } from './helpers'

import './ResponsiveImage.scss'

const ImgPropTypes = {
  className: string,
  alt: string.isRequired,
  sizes: sizesPropType.isRequired,
  srcSet: srcSetPropType.isRequired,
  width: number.isRequired,
  height: number.isRequired,
  lazyLoad: bool,
  preconnect: bool,
}

const ImgDefaultProps = {
  className: null,
  lazyLoad: false,
  preconnect: false,
}

type ImgProps = InferPropsWithDefaults<
  typeof ImgPropTypes,
  typeof ImgDefaultProps
>

const Img = ({
  className,
  alt,
  sizes,
  srcSet,
  lazyLoad,
  preconnect,
  width,
  height,
  ...otherProps
}: ImgProps) => {
  const sortedSrcSet = srcSet ? sortSrcSet(srcSet) : {}
  const src: string = chooseSrcByWidth(sortedSrcSet, width)
  const preconnectHref = preconnect && src ? new URL(src).origin : false

  return (
    <>
      {preconnectHref && (
        <Helmet>
          <link rel="preconnect" href={preconnectHref} />
        </Helmet>
      )}
      <img
        className={classnames('a-ResponsiveImage__img', className)}
        alt={alt}
        sizes={sizes ? transformSizes(sizes) : null}
        srcSet={srcSet ? transformSrcSet(sortedSrcSet) : null}
        src={src}
        width={width}
        height={height}
        loading={lazyLoad ? 'lazy' : null}
        {...otherProps}
      />
    </>
  )
}

Img.propTypes = ImgPropTypes
Img.defaultProps = ImgDefaultProps

export default Img
